import {InstituicaoEnsino} from './instituicaoEnsino.model';
import {Usuario} from './usuario.model';
import {TipoServico} from './tiposervicos.model';
import {LinhaOnibus} from './linhaOnibus.model';
import {PendingData} from './pendingData.model';
import {LogData} from './logData.model';
import {Pagamento} from './pagamento.model';

export class Agendamento {
    public agencyId: Number;
    public attachmentList: Number[];
    public busServiceVOList: LinhaOnibus[];
    public createdDate: Number;
    public institutionData: InstituicaoEnsino;
    public modifiedDate: Number;
    public protocol: String;
    public selectedDate: Number;
    public serviceId: Number;
    public serviceLocation: String;
    public serviceLocationId: Number;
    public serviceLocationAddress: String;
    public serviceName: String;
    public serviceTypeVO: TipoServico;
    public status: String;
    public statusType: String;
    public transportCardNumber: String;
    public userData: Usuario;
    public canCancel: Boolean;
    public customerDescription: String;
    public pendingDataList: PendingData[];
    public attendanceAnswer: String;
    public logDataList: LogData[];
    public pagamento: Pagamento;
    public needPayment: Boolean;
    public serviceNeedPayment: Boolean;
    public appointment: Boolean;
    public valueOfService: number;
    public requirerType: String;
    public delivery: String;
    public serviceShippingCostId: Number;
    public shippingInfo: Usuario;
    public termos: boolean;
    public ip: String;
    public abtServiceTypeId: number;
    public requireSocialName: boolean;

    constructor() {
        this.userData = new Usuario();
        this.institutionData = new InstituicaoEnsino();
        this.pagamento = new Pagamento();
        this.attachmentList = [];
        this.busServiceVOList = [];
        this.pendingDataList = [];
        this.logDataList = [];

    }
}
